import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  note = `● 推廣正確的動物友善教育\n● 蒐集並推動動保資訊的普及與數位化\n● 執行與動物或生態保育議題相關科學技術研究發展計畫\n● 辦理動物或生態保育議題相關的培訓或研討會`;
}
